// src/hooks/useAuth.ts
import { useContext } from 'react';
import { AuthContext, type AuthUser } from '../contexts/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return context;
};

// Exporter également le type AuthUser si besoin
export type { AuthUser };